export const initialState = {
	navDrawerOpen: false,
};
